import OAuthRedirect from '../components/OAuthRedirect';

export default function SamsaraRedirect() {
  return <OAuthRedirect TSP='Samsara' />;
}
